import moment from "moment";
import "moment/locale/en-gb";
import "moment/locale/fi";
import "moment/locale/nb";
import "moment/locale/sv";
import $ from "jquery";
import "jquery-ui/ui/widgets/datepicker";
import "jquery-ui/ui/i18n/datepicker-en-GB";
import "jquery-ui/ui/i18n/datepicker-fi";
import "jquery-ui/ui/i18n/datepicker-nb";
import "jquery-ui/ui/i18n/datepicker-sv";
import environment from "flow/configuration/environment";
import {
    cultureAdjustForJQueryUI,
    getJQueryUIDatepickerFormat,
    cultureAdjustForMoment,
    getMomentDateFormat
} from "flow/localization/dateFormat";
import { setupValidationLanguage } from "flow/knockout/validationSetup";

export function setup(uiCulture: string) {
    const culture = environment.getCulture();
    setupValidationLanguage(uiCulture);
    moment.locale(cultureAdjustForMoment(uiCulture), getMomentDateFormat(culture));
    setJQueryUIDatepickerCulture(culture, uiCulture);
}

function setJQueryUIDatepickerCulture(culture: string, uiCulture: string) {
    const datepickerCulture = uiCulture ? cultureAdjustForJQueryUI(uiCulture) : "en-GB";

    const options: JQueryUI.DatepickerOptions = {
        ...$.datepicker.regional[datepickerCulture],
        dateFormat: getJQueryUIDatepickerFormat(culture)
    };

    $.datepicker.setDefaults(options);
}

function generateMonthListShort() {
    const mom = moment([2000, 1, 1]);
    const list = [];
    for (let i = 0; i < 12; i++) {
        mom.month(i);
        list.push(mom.format("MMM"));
    }
    return list;
}

let monthList: string[];

export function getMonthListShort() {
    if (monthList) {
        return monthList;
    }

    // In case it runs before setUiCulture use temporary list
    return generateMonthListShort();
}
